import React from 'react';
import { connect } from "react-redux";
import {setWallsUpMode} from "../../../../../actions/sqftMenuFunctions";

const WallsUpModeButton = (props) => {
  const {isWallsUpMode, setWallsUpMode} = props;

  const handleButtonClick = () => {
    setWallsUpMode(!isWallsUpMode);
  };

  return (
    <div className="ui-button-block">
      <button className={"button--rounded button--compass-white " + (isWallsUpMode ? "button-active" : null)}
              onClick={handleButtonClick}>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => ({
  isWallsUpMode: store.sqftMenuState.isWallsUpMode,
});

const mapDispatchToProps = {
  setWallsUpMode
};

export default connect(mapStateToProps, mapDispatchToProps)(WallsUpModeButton);
